import moment from 'moment';
import { setRequestContentType } from './components/lib/AxiosUtils';

/* ------------------------
    CREATE URL
--------------------------*/
function createURL() {
  let url = 'http://localhost:8000/api/';
  if (process.env.REACT_APP_BACKEND_URL) {
    url = process.env.REACT_APP_BACKEND_URL;
  } else {
    url = `https://api.${document.location.hostname}/api/`;
  }

  return url;
}

/* ------------------------
    CONSTANTS
--------------------------*/
export default class Constants {
  static URL = createURL();

  static USER_DELETE_MSG =
    'Warning: Deleting a User here removes their access to the Tarot Supply Chain Managment ' +
    'product, but NOT the remainder of the Boab product. \n\n Are you sure you want to delete this user?';

  static ORGANISATIONS_DELETE_MSG =
    'Warning: Deleting an Organisation has several impacts:\n\n- ' +
    'Users at the Organisation will not be able to access the Tarot Supply Chain Managment product.\n- ' +
    'Grinders, Packers, Input Products and Output Products which belong to the Organisation will' +
    // eslint-disable-next-line no-template-curly-in-string
    " henceforth belong to the Organisation's parent organisation PARENT ${name} , " +
    // eslint-disable-next-line no-template-curly-in-string
    'and will be visible to all Users who can access it.\n\nAre you sure you want to delete ${name}?';

  static ROLES_DELETE_MSG =
    'Warning: If any Users have this role, deleting it will make those ' +
    // eslint-disable-next-line no-template-curly-in-string
    'accounts unusable until they are assigned a new role.\n\nAre you sure you want to delete ${name}?';

  static INPUT_PRODUCTS_DELETE_MSG =
    'Warning: This will DELETE ALL DATA associated with this Input ' +
    'Product.\n\nThis Includes ALL:\n- Input Product Inventory Items\n- Packer Input Product Inventory ' +
    'Items\n- Orders\n- Order Line Items\nwhich refer to this Input Product.\n\nAre you sure you want ' +
    // eslint-disable-next-line no-template-curly-in-string
    'to delete ${uid} ?';

  static OUTPUT_PRODUCTS_DELETE_MSG =
    'Warning: This will DELETE ALL DATA associated with this Output ' +
    'Product.\n\nThis Includes ALL:\n- Output Product Inventory Items\n- Forecasts (Production Planner)\n- ' +
    'Orders\n- Order Line Items\nwhich refer to this Output Product.\n\nAre you sure you want to ' +
    // eslint-disable-next-line no-template-curly-in-string
    'delete ${uid}?';

  static GRINDER_DELETE_MSG =
    'Warning: This will DELETE ALL DATA associated with this Grinder.\n\nThis ' +
    'Includes ALL:\n- Output Product Inventory Items\n- Forecasts (Production Planner)\n- Input Product ' +
    'Inventory Items\n- Orders\n- Order Line Items\n- Transport\nwhich refer to this Grinder.\n\nAre you ' +
    // eslint-disable-next-line no-template-curly-in-string
    'sure you want to delete ${name}?';

  static PACKER_PLANTS_DELETE_MSG =
    'Warning: This will DELETE ALL DATA associated with this Packer\n\nThis ' +
    'Includes ALL:\n- Packer Input Product Inventory Items\n- Orders\n- Order Line Items\n- Transport\nwhich ' +
    // eslint-disable-next-line no-template-curly-in-string
    'refer to this Packer.\n\nAre you sure you want to delete ${name}?';

  static TRANSPORTERS_DELETE_MSG =
    'Warning: This will DELETE ALL DATA associated with this Transporter\n\nThis ' +
    'means orders with this transporter will have carrier field set to null.\n\nAre you sure you want ' +
    // eslint-disable-next-line no-template-curly-in-string
    'to delete ${name}?';

  static ESTABLISHMENT_GROUP_DELETE_MSG =
    'Warning: This will DELETE ALL DATA associated with this Establishment ' +
    // eslint-disable-next-line no-template-curly-in-string
    'Group\n\nAre you sure you want to delete ${name}?';

  static FORM_FIELDS_DELETE_MSG =
    'Warning: This will DELETE ALL DATA associated with this Form Field\n\nAre ' +
    // eslint-disable-next-line no-template-curly-in-string
    'you sure you want to delete ${value}?';

  static VALUES_NOT_IN_RANGE_ERROR =
    'Please ensure Min Fresh and Min 50s have a value between (or including) 0 and 100.';

  static EMPTY_INPUT_PRODUCT_VALUES_ERROR = 'Please ensure beef product has a Name, Cl, Min Fresh, and Min 50s.';

  static EMPTY_GRINDER_VALUES_ERROR = 'Please ensure grinder has a name and organisation ID.';

  static EMPTY_TRANSPORTER_VALUES_ERROR = 'Please ensure transporter has a name.';

  static EMPTY_ROLE_ERROR = 'Please ensure role has a name.';

  static EMPTY_ORGANISATION_ERROR = 'Please ensure organisation has a name, parent ID and Uid.';

  static EMPTY_CONFIG_ERROR = 'Please ensure config has a name.';

  static EMPTY_USER_ERROR = 'Please ensure email, organisation ID, and role ID are filled in.';

  static EMPTY_PACKER_PLANT_ERROR = 'Please ensure packer_plant has a name and organisation ID.';

  static EMPTY_PACKER_PLANT_EST_GROUP_ERROR =
    'Please ensure packer_plant establishment group has a name and packer_plant IDs.';

  static EMPTY_FORM_FIELD_ERROR = 'Please ensure form has a type and value.';

  static EMPTY_BEEF_INPUT_PRODUCT_ERROR = 'Please ensure beef product has a name.';

  // eslint-disable-next-line no-template-curly-in-string
  static DELIST_INPUT_PRODUCT_WARNING = 'Are you sure you want to ${status} beef product?';

  // eslint-disable-next-line no-template-curly-in-string
  static DELIST_PACKER_PLANT_WARNING = 'Are you sure you want to ${status} packer?';

  static DELETE_LOAD_SIZE_WARNING = 'Are you sure you want to delete load size?';

  static DELETE_UNITS_OF_MEASURE = 'Are you sure you want to delete unit of measure?';

  // eslint-disable-next-line no-template-curly-in-string
  static GENERIC_DELETE_MSG = 'Are you sure you want to delete ${name}?';

  static CONFIRM_ORDER_FINALIZE_MSG =
    'Order is confirmed.<br />PO# is generated and messages sent to Netsuite/Grinders';

  static BIN_SIZE = 2000;

  static PO_FORM_TYPE = {
    AUSTRALIA_DOMESTIC: 'AUSTRALIA_DOMESTIC',
    AUSTRALIA_INTERNATIONAL: 'AUSTRALIA_INTERNATIONAL',
    AMERICA_DOMESTIC: 'AMERICA_DOMESTIC',
  };

  static FORM_ATTRIBUTES = {
    HAS_VOYAGE_DETAILS: 'HAS_VOYAGE_DETAILS',
    IS_AMERICAN_DOMESTIC: 'IS_AMERICAN_DOMESTIC', // Packer plant and grinder are both either USA or Canada
    IS_EUROPE_DOMESTIC: 'IS_EUROPE_DOMESTIC', // Packer plant and grinder are both either USA or Canada
    IS_AUSTRALIAN_DOMESTIC: 'IS_AUSTRALIAN_DOMESTIC', // Packer plant and grinder are both either AUS or NZ
    IS_GENERAL_DOMESTIC: 'IS_GENERAL_DOMESTIC',
    RECURRING_ENABLED: 'RECURRING_ENABLED',
    HAS_PACKER_AND_GRINDER: 'HAS_PACKER_AND_GRINDER', // packer, packer plant, and grinder have been selected
  };

  static ORDER_STATUSES = {
    PENDING: 'pending',
    ORDERED: 'ordered',
    CANCELLED: 'cancelled',
    SUBMITTED: 'submitted',
    RECEIVED: 'received',
    COLDSTORE: 'coldstore',
    PENDING_COLDSTORE_SCHEDULE: 'pending_coldstore_schedule',
    PENDING_COLDSTORE_RELEASE: 'pending_coldstore_release',
    PENDING_COLDSTORE_EMAIL: 'pending_coldstore_email',
    COLDSTORE_RELEASED: 'coldstore_released',
    INVOICED: 'invoiced',
    DISPATCHED: 'dispatched',
    ON_THE_WATER: 'on_the_water',
    ON_HOLD: 'on_hold',
    TRANSFERRED: 'transferred',
    DRAFT: 'draft',
  };

  static asianCountries = ['Malaysia', 'Taiwan', 'UAE', 'Japan', 'China', 'Philippines', 'South Korea'];

  static INVOICE_STATUSES = {
    TODO: 'todo',
    INVOICED: 'invoiced',
    INVOICED_PRIOR: 'invoiced_prior',
    PAID: 'paid',
  };

  static INVOICE_TYPES = {
    PRIOR: 'PRIOR',
    FINAL: 'FINAL',
    REGULAR: 'REGULAR',
  };

  static INVOICE_FLOWS = {
    PRIOR_FINAL: 'prior_final',
    REGULAR: 'regular',
  };

  static INVOICE_TEMPLATE_TYPES = {
    DEFAULT: 'DEFAULT',
    TAX_ID: 'TAX_ID',
    TAX_EU_ID: 'TAX_EU_ID',
  };

  static PO_STRATEGY = {
    CUSTOM: 'Custom',
    MANUAL: 'Manual',
    SEQUENCE: 'Sequence',
    SEQUENCE_EDITABLE: 'Sequence_Editable',
  };

  static PRICE_STATUSES = { LOCKED: 'locked', UNLOCKED: 'unlocked' };

  static DEFAULT_EXCHANGE_RATE = 1;

  static FAHRENHEIT = '°F';

  static CELSIUS = '°C';

  static KELVIN = 'K';

  // TODO get rid of hardcoded ids
  static TEMPERATURE_MEASUREMENT_UNITS = [
    { value: 1, label: '°F' },
    { value: 2, label: '°C' },
    { value: 3, label: 'K' },
  ];

  static handleErrors = (response, dispatch, errorMethod) => {
    const statusString = response.status ? response.status.toString() : '';
    if (!response.ok && !statusString.includes('20')) {
      if (response.status === 500) {
        throw Error('Something went wrong. We are working on it!');
      } else {
        if ([400, 415, 403, 409].includes(response.status) && errorMethod) {
          if (response.data) {
            return new Promise(() => dispatch(errorMethod(JSON.stringify(response.data))));
          }

          return new Promise(() => response.json().then(json => dispatch(errorMethod(JSON.stringify(json)))));
        }
        throw Error(response.statusText);
      }
    }
    if (response.status !== 204) {
      return response.json ? response.json() : response.data;
    }
    return response;
  };

  static DEFAULT_READ_DATE_FORMAT = 'YYYY-MM-DD';

  static DATE_CREATED_START_END = 'Date Created Start/End';

  static DATE_DELIVERY_START_END = 'Delivery Date Start/End';

  static PO_SEARCH = 'PO # Search';

  static GRINDER = 'Grinder';

  static DELIVERY_DATE = 'Delivery Date';

  static ACTUAL_DELIVERY_DATE = 'Actual Delivery Date';

  static DELIVERY_DAY = 'Delivery Day';

  static ACTUAL_DELIVERY_DAY = 'Actual Delivery Day';

  static PURCHASE_ORDER = 'PO#';

  static PACKER_PLANT = 'Establishment';

  static ESTABLISHMENT_ID = 'Establishment ID';

  static PRODUCT = 'Product';

  static PRODUCT_CL = 'Product CL';

  static EDIT_POPUP_CL = 'Ordered';

  static PRODUCT_TYPE = 'Product Type';

  static PRODUCT_CATEGORY = 'Product Category';

  static PROTEIN_TYPE = 'Protein Type';

  static GRINDER_TESTED = 'Grinder Tested';

  static THIRD_PARTY_TESTED = 'Third Party Tested';

  static ORDERED = 'Ordered';

  static RECEIVED = 'Received';

  static FOB = 'FOB';

  static FREIGHT_RATE = 'Freight Rate';

  static PACKER_PLANT_DELIVERED = 'Packer Delivered';

  static GRINDER_DELIVERED = 'Grinder Delivered';

  static FMG_COMMENTS = 'FMG Comments';

  static COMMENTS = 'Comments';

  static ORDER_TYPE = 'Order Type';

  static EXPECTED_PRODUCTION_DATE = 'Expected Production Date';

  static APPOINTMENT_TIME = 'Appointment Time';

  static PACKER_PLANT_SO = 'Packer SO#';

  static PO_DISPOSITION = 'PO Disposition';

  static ORIGIN_COUNTRY = 'Origin Country';

  static DESTINATION_COUNTRY = 'Destination Country';

  static STATUS = 'Status';

  static LINE_STATUS = 'Line Status';

  static ORDER_STATUS = 'Order Status';

  static GRINDER_DELIVERED_PRICE = 'Grinder Delivered Price';

  static TRANSPORTER_ID = 'Carrier';

  static DROP_TRAILER = 'Drop Trailer';

  static CURRENCY_SYMBOLS = {
    'USD': '$',
    'AUD': '$',
    'EUR': '€',
    'GBP': '£',
    'JPY': '¥',
    'PLN': 'zł',
  };

  static PRICING_STRATEGY = {
    MANUAL: 'manual',
    DEFAULT: 'default',
    COMBINE: 'combine',
  };

  static EMAIL = {
    SINGLE: {
      // eslint-disable-next-line no-template-curly-in-string
      SUBJECT: 'FMG ${documentType} for ${fmgOrGrinderPOs}: ${firstPoNumber}',

      CONTENT:
        'To whom it may concern,\n\n' +
        // eslint-disable-next-line no-template-curly-in-string
        'Please find attached the ${documentType} for ${fmgOrGrinderPOs}: ${firstPoNumber}\n\n' +
        'Any queries?  Email sales@fultonmarketgroup.com\n\n' +
        'Thanks,\n' +
        'FMG Australia Team',
    },

    MULTIPLE: {
      // eslint-disable-next-line no-template-curly-in-string
      SUBJECT: 'FMG ${documentType} ${fmgOrGrinderPOs}: ${firstPoNumber} - ${lastPoNumber}',

      CONTENT:
        'To whom it may concern,\n' +
        // eslint-disable-next-line no-template-curly-in-string
        'Please find attached the ${documentType} for ${fmgOrGrinderPOs}: ' +
        // eslint-disable-next-line no-template-curly-in-string
        '${firstPoNumber} - ${lastPoNumber}.\n\n' +
        'Any queries?  Email sales@fultonmarketgroup.com\n\n' +
        'Thanks,\n' +
        'FMG Australia Team',
    },
  };

  static PASSWORD_VALIDATION = {
    MIN: 12,
    MAX: 70,
    SPECIAL_CHARS: '!@#$%&*~_+',
    FORBIDDEN_CHARS: `'"`,
  };

  static getHardcodedName(dbName) {
    switch (dbName.toLowerCase()) {
      case 'price_type':
        return Constants.ORDER_TYPE;
      case 'price_per_unit':
        return Constants.FOB;
      case 'cl':
        return Constants.PRODUCT_CL;
      case 'packer_so_number':
        return Constants.PACKER_PLANT_SO;
      case 'recv_delivery_date':
        return Constants.ACTUAL_DELIVERY_DATE;
      case 'fmg_comments':
        return Constants.FMG_COMMENTS;
      case 'comments':
        return Constants.COMMENTS;
      case 'po_disposition':
        return Constants.PO_DISPOSITION;
      case 'destination_country':
        return Constants.DESTINATION_COUNTRY;
      case 'delivery_date':
        return Constants.DELIVERY_DATE;
      case 'origin_country':
        return Constants.ORIGIN_COUNTRY;
      case 'number_of_bins':
        return Constants.ORDERED;
      case 'scheduled_delivery_time':
        return Constants.APPOINTMENT_TIME;
      case 'grinder_tested_cl':
        return Constants.GRINDER_TESTED;
      case 'third_party_tested_cl':
        return Constants.THIRD_PARTY_TESTED;
      case 'recv_quantity':
        return Constants.RECEIVED;
      case 'expected_production_date':
        return Constants.EXPECTED_PRODUCTION_DATE;
      case 'input_product_uid':
        return Constants.PRODUCT;
      case 'transport_cost_per_unit':
        return Constants.FREIGHT_RATE;
      case 'packer_plant_id':
        return Constants.PACKER_PLANT;
      case 'grinder_del_dollars':
        return Constants.GRINDER_DELIVERED;
      case 'packer_delivered_price':
        return Constants.PACKER_PLANT_DELIVERED;
      case 'active':
        return Constants.LINE_STATUS;
      case 'status':
        return Constants.ORDER_STATUSES;
      case 'grinder_delivered_price':
        return Constants.GRINDER_DELIVERED_PRICE;
      case 'transporter_id':
        return Constants.TRANSPORTER_ID;
      case 'drop_trailer':
        return Constants.DROP_TRAILER;
      default:
        return dbName;
    }
  }

  static PO_DISPOSITION_LIST = [
    { value: '1', label: 'Unplanned' },
    { value: '2', label: 'Planned' },
  ];

  static PRICE_TYPE_LIST = [
    { value: 'spot', label: 'Spot' },
    { value: 'formula', label: 'Formula' },
    { value: 'contract', label: 'Contract' },
    { value: 'nof', label: 'NOF' },
    { value: 'other', label: 'Other' },
  ];

  static MISSING_DOC_TYPE_LIST = [
    {
      value: 'Grinder Copy Documents',
      label: 'Grinder Copy Documents',
    },
    {
      value: 'Forwarding Instructions',
      label: 'Forwarding Instructions',
    },
    {
      value: 'ISF',
      label: 'ISF',
    },
  ];

  static PRICE_NUMBER_FIELD_PATTERN = '[0-9]+([.,][0-9]+)?';

  static PO_DOC_TYPES = {
    SALE: 'Sale',
    PURCHASE: 'Purchase',
  };

  static DROP_TRAILER_LIST = [
    { value: '', label: 'None' },
    { value: true, label: 'Yes' },
    { value: false, label: 'No' },
  ];

  /* TODO - need a more practical solution for handling all countries globally as
   *  we presently don't have many packers from every continent of the world yet.
   *  This is fine for now.
   */

  static COUNTRIES = {
    ARGENTINA: 'argentina',
    AUSTRALIA: 'australia',
    BRAZIL: 'brazil',
    CANADA: 'canada',
    CHINA: 'china',
    IRELAND: 'ireland',
    JAPAN: 'japan',
    KOREA: 'korea',
    MALAYSIA: 'malaysia',
    NEW_ZEALAND: 'new zealand',
    PHILIPINES: 'philippines',
    POLAND: 'poland',
    TAIWAN: 'taiwan',
    UAE: 'uae',
    URUGUAY: 'uruguay',
    USA: 'usa',
    MEXICO: 'mexico',
    NICARAGUA: 'nicaragua',
    COSTA_RICA: 'costa rica',
    BOLIVIA: 'bolivia',
    ALBANIA: 'albania',
    ANDORRA: 'andorra',
    ARMENIA: 'armenia',
    AUSTRIA: 'austria',
    AZERBAIJAN: 'azerbaijan',
    BELARUS: 'belarus',
    BELGIUM: 'belgium',
    BOSNIA_AND_HERZEGOVINA: 'bosnia and herzegovina',
    BULGARIA: 'bulgaria',
    CROATIA: 'croatia',
    CYPRUS: 'cyprus',
    CZECH_REPUBLIC: 'czech republic',
    DENMARK: 'denmark',
    ESTONIA: 'estonia',
    FINLAND: 'finland',
    FRANCE: 'france',
    GEORGIA: 'georgia',
    GERMANY: 'germany',
    GREECE: 'greece',
    HUNGARY: 'hungary',
    ICELAND: 'iceland',
    ITALY: 'italy',
    LATVIA: 'latvia',
    LITHUANIA: 'lithuania',
    LUXEMBOURG: 'luxembourg',
    MALTA: 'malta',
    MOLDOVA: 'moldova',
    MONACO: 'monaco',
    MONTENEGRO: 'montenegro',
    NETHERLANDS: 'netherlands',
    NORTH_MACEDONIA: 'north macedonia',
    NORWAY: 'norway',
    PORTUGAL: 'portugal',
    ROMANIA: 'romania',
    RUSSIA: 'russia',
    SAN_MARINO: 'san marino',
    SERBIA: 'serbia',
    SLOVAKIA: 'slovakia',
    SLOVENIA: 'slovenia',
    SPAIN: 'spain',
    SWEDEN: 'sweden',
    SWITZERLAND: 'switzerland',
    UKRAINE: 'ukraine',
    UNITED_KINGDOM: 'united kingdom',
    VATICAN_CITY: 'vatican city',
  };

  static COUNTRY_CODINGS = [
    { code: 'AE', name: Constants.COUNTRIES.UAE },
    { code: 'AR', name: Constants.COUNTRIES.ARGENTINA },
    { code: 'AU', name: Constants.COUNTRIES.AUSTRALIA },
    { code: 'BR', name: Constants.COUNTRIES.BRAZIL },
    { code: 'CA', name: Constants.COUNTRIES.CANADA },
    { code: 'CN', name: Constants.COUNTRIES.CHINA },
    { code: 'IE', name: Constants.COUNTRIES.IRELAND },
    { code: 'JP', name: Constants.COUNTRIES.JAPAN },
    { code: 'KP', name: Constants.COUNTRIES.KOREA },
    { code: 'MY', name: Constants.COUNTRIES.MALAYSIA },
    { code: 'MX', name: Constants.COUNTRIES.MEXICO },
    { code: 'NZ', name: Constants.COUNTRIES.NEW_ZEALAND },
    { code: 'PH', name: Constants.COUNTRIES.PHILIPINES },
    { code: 'PL', name: Constants.COUNTRIES.POLAND },
    { code: 'TW', name: Constants.COUNTRIES.TAIWAN },
    { code: 'UK', name: Constants.COUNTRIES.UNITED_KINGDOM },
    { code: 'US', name: Constants.COUNTRIES.USA },
    { code: 'UY', name: Constants.COUNTRIES.URUGUAY },
    { code: 'NI', name: Constants.COUNTRIES.NICARAGUA },
    { code: 'CR', name: Constants.COUNTRIES.COSTA_RICA },
    { code: 'BO', name: Constants.COUNTRIES.BOLIVIA },
    { code: 'AL', name: Constants.COUNTRIES.ALBANIA },
    { code: 'AD', name: Constants.COUNTRIES.ANDORRA },
    { code: 'AM', name: Constants.COUNTRIES.ARMENIA },
    { code: 'AT', name: Constants.COUNTRIES.AUSTRIA },
    { code: 'AZ', name: Constants.COUNTRIES.AZERBAIJAN },
    { code: 'BY', name: Constants.COUNTRIES.BELARUS },
    { code: 'BE', name: Constants.COUNTRIES.BELGIUM },
    { code: 'BA', name: Constants.COUNTRIES.BOSNIA_AND_HERZEGOVINA },
    { code: 'BG', name: Constants.COUNTRIES.BULGARIA },
    { code: 'HR', name: Constants.COUNTRIES.CROATIA },
    { code: 'CY', name: Constants.COUNTRIES.CYPRUS },
    { code: 'CZ', name: Constants.COUNTRIES.CZECH_REPUBLIC },
    { code: 'DK', name: Constants.COUNTRIES.DENMARK },
    { code: 'EE', name: Constants.COUNTRIES.ESTONIA },
    { code: 'FI', name: Constants.COUNTRIES.FINLAND },
    { code: 'FR', name: Constants.COUNTRIES.FRANCE },
    { code: 'GE', name: Constants.COUNTRIES.GEORGIA },
    { code: 'DE', name: Constants.COUNTRIES.GERMANY },
    { code: 'GR', name: Constants.COUNTRIES.GREECE },
    { code: 'HU', name: Constants.COUNTRIES.HUNGARY },
    { code: 'IS', name: Constants.COUNTRIES.ICELAND },
    { code: 'IT', name: Constants.COUNTRIES.ITALY },
    { code: 'LV', name: Constants.COUNTRIES.LATVIA },
    { code: 'LT', name: Constants.COUNTRIES.LITHUANIA },
    { code: 'LU', name: Constants.COUNTRIES.LUXEMBOURG },
    { code: 'MT', name: Constants.COUNTRIES.MALTA },
    { code: 'MD', name: Constants.COUNTRIES.MOLDOVA },
    { code: 'MC', name: Constants.COUNTRIES.MONACO },
    { code: 'ME', name: Constants.COUNTRIES.MONTENEGRO },
    { code: 'NL', name: Constants.COUNTRIES.NETHERLANDS },
    { code: 'MK', name: Constants.COUNTRIES.NORTH_MACEDONIA },
    { code: 'NO', name: Constants.COUNTRIES.NORWAY },
    { code: 'PT', name: Constants.COUNTRIES.PORTUGAL },
    { code: 'RO', name: Constants.COUNTRIES.ROMANIA },
    { code: 'RU', name: Constants.COUNTRIES.RUSSIA },
    { code: 'SM', name: Constants.COUNTRIES.SAN_MARINO },
    { code: 'RS', name: Constants.COUNTRIES.SERBIA },
    { code: 'SK', name: Constants.COUNTRIES.SLOVAKIA },
    { code: 'SI', name: Constants.COUNTRIES.SLOVENIA },
    { code: 'ES', name: Constants.COUNTRIES.SPAIN },
    { code: 'SE', name: Constants.COUNTRIES.SWEDEN },
    { code: 'CH', name: Constants.COUNTRIES.SWITZERLAND },
    { code: 'UA', name: Constants.COUNTRIES.UKRAINE },
    { code: 'GB', name: Constants.COUNTRIES.UNITED_KINGDOM },
    { code: 'VA', name: Constants.COUNTRIES.VATICAN_CITY },
  ];

  static AMERICA_DOMESTIC_COUNTRIES = [Constants.COUNTRIES.USA, Constants.COUNTRIES.CANADA];

  static AUSTRALIA_DOMESTIC_COUNTRIES = [Constants.COUNTRIES.AUSTRALIA, Constants.COUNTRIES.NEW_ZEALAND];

  static EUROPEAN_DOMESTIC_LIST = [
    Constants.COUNTRIES.ALBANIA,
    Constants.COUNTRIES.ANDORRA,
    Constants.COUNTRIES.ARMENIA,
    Constants.COUNTRIES.AUSTRIA,
    Constants.COUNTRIES.AZERBAIJAN,
    Constants.COUNTRIES.BELARUS,
    Constants.COUNTRIES.BELGIUM,
    Constants.COUNTRIES.BOSNIA_AND_HERZEGOVINA,
    Constants.COUNTRIES.BULGARIA,
    Constants.COUNTRIES.CROATIA,
    Constants.COUNTRIES.CYPRUS,
    Constants.COUNTRIES.CZECH_REPUBLIC,
    Constants.COUNTRIES.DENMARK,
    Constants.COUNTRIES.ESTONIA,
    Constants.COUNTRIES.FINLAND,
    Constants.COUNTRIES.FRANCE,
    Constants.COUNTRIES.GEORGIA,
    Constants.COUNTRIES.GERMANY,
    Constants.COUNTRIES.GREECE,
    Constants.COUNTRIES.HUNGARY,
    Constants.COUNTRIES.ICELAND,
    Constants.COUNTRIES.IRELAND,
    Constants.COUNTRIES.ITALY,
    Constants.COUNTRIES.LATVIA,
    Constants.COUNTRIES.LITHUANIA,
    Constants.COUNTRIES.LUXEMBOURG,
    Constants.COUNTRIES.MALTA,
    Constants.COUNTRIES.MOLDOVA,
    Constants.COUNTRIES.MONACO,
    Constants.COUNTRIES.MONTENEGRO,
    Constants.COUNTRIES.NETHERLANDS,
    Constants.COUNTRIES.NORTH_MACEDONIA,
    Constants.COUNTRIES.NORWAY,
    Constants.COUNTRIES.PORTUGAL,
    Constants.COUNTRIES.ROMANIA,
    Constants.COUNTRIES.RUSSIA,
    Constants.COUNTRIES.SAN_MARINO,
    Constants.COUNTRIES.SERBIA,
    Constants.COUNTRIES.SLOVAKIA,
    Constants.COUNTRIES.SLOVENIA,
    Constants.COUNTRIES.SPAIN,
    Constants.COUNTRIES.SWEDEN,
    Constants.COUNTRIES.SWITZERLAND,
    Constants.COUNTRIES.UKRAINE,
    Constants.COUNTRIES.VATICAN_CITY,
  ];

  static PRODUCT_INGREDIENT_SPECIFICATIONS = [
    {
      label: 'FMG Angus',
      value: 'fmgAngus',
    },
    {
      label: 'USDA Angus',
      value: 'usdaAngus',
    },
    {
      label: 'Grain Fed',
      value: 'grainFed',
    },
    {
      label: 'Grass Fed',
      value: 'grassFed',
    },
    {
      label: 'Sustainable',
      value: 'sustainable',
    },
    {
      label: 'Wagyu',
      value: 'wagyu',
    },
  ];

  static WEIGHT_TYPES = {
    po_weight: 'PO Weight',
    shipped_weight: 'Shipped Weight',
    remaining_weight: 'Remaining Weight',
    received_weight: 'Received Weight',
  };

  /*  po_lines model, to be used when referring to po_line obj 
      same as po_line = PO_Line() , empty obj of po_line model
      doesns't include auto-generated p.k column 'id'
  */
  static PO_LINE_OBJ = {
    active: true,
    purchase_order_id: null,
    input_product_uid: null,
    line_number: null,
    number_of_bins: null,
    price_type: null,
    price_per_unit: null,
    fabrication_date: null,
    contract_start_date: null,
    contract_end_date: null,
    formula_name: null,
    formula_market: null,
    formula_day: null,
    formula_days_averaged: null,
    formula_basis: null,
    recv_quantity: null,
    processed_date: null,
    processed_time: null,
    processed_quantity: null,
    work_order_number: null,
    price: null,
    old_quantity: null,
    // can be made null when UnitConverter convert_to_grams accepts null
    buy_quantity: 0,
    sell_quantity: 0,
    specifications: [],
    chilled: true,
    frozen: false,
    buy_price_per_unit: null,
    sell_price_per_unit: null,
    group_housed_premium_rate: 0,
    buy_price: null,
    sell_price: null,
    packer_plant_id: null,
    packer_plant: null,
    expected_production_date: null,
    package_count: 0,
    package_type: null,
    productionDetails: [],
    estimatedProductionDetails: [],
  };

  static PACKAGE_TYPE = {
    CARTON: 'CTN',
    BIN: 'BIN',
  };

  static UNIT_OF_MEASURE = [
    {
      id: 1,
      value: 'POUND',
    },
    {
      id: 2,
      value: 'KILOGRAM',
    },
    {
      id: 3,
      value: 'CARTON',
    },
  ];

  static INITIAL_EXPORT_DETAILS = {
    healthCertificateNumber: null,
    isf: null,
    permitNumber: null,
    containerDepot: null,
    containerReturn: null,
    containerGateInDate: null,
    // Important Dates
    docsReceivedDate: null,
    isfReceivedDate: null,
    docsToCustomBrokerDate: null,
    docsToBankDate: null,
    importPermit: null,
    importPermitExpiry: null,
  };

  static INITIAL_VOYAGE = {
    voyageNumber: null,
    vesselName: null,
    shippingLineId: null,
    loadPortId: null,
    dischargePortId: null,
    eta: null,
    etd: null,
    transhipPortId: null,
    voaygeLegId: null,
  };

  static INITIAL_BOL = {
    bolNumber: '',
    bookingReferenceNumber: '',
    containerNumber: '',
    containerTemperature: '',
    sealNumber: '',
    exportDeclarationNumber: '',
    grossShippedWeight: null,
    shipmentPortMarks: [],
  };

  static INITIAL_COLDSTORE = {
    coldStoreId: false,
    dateOfEntry: null,
    inspectionDate: null,
    lotNumbers: [],
    containerFrontTemp: null,
    containerMiddleTemp: null,
    containerBackTemp: null,
    overRedLine: false,
    temperatureMeasurementUnitId: Constants.TEMPERATURE_MEASUREMENT_UNITS.find(
      unit => unit.label === Constants.FAHRENHEIT
    ).value,
    customedClearedDate: null,
  };

  static createPurchaseOrderFee(feeName, purchaseOrderId) {
    return {
      ...(purchaseOrderId && { purchase_order_id: purchaseOrderId }),
      feeName,
      amount: '',
      estimate: '',
      currency: 'USD',
    };
  }

  static REJECTED_CARTON_REQUIRED_FIELDS = [
    'numberOfRejectedCartons',
    'rejectionDate',
    'reasonForRejection',
    'lineNumber',
    'productionDate',
  ];

  static INITIAL_REJECTED_CARTON = {
    numberOfRejectedCartons: '',
    rejectionDate: moment().format('YYYY-MM-DD'), // TODAY
    reasonForRejection: '',
    lineNumber: '',
    productionDate: '',
    lotNumber: '',
    shipmentPortMark: '',
  };

  static PRODUCT_INGREDIENT_SPECIFICATIONS_KEY_PAIR = {
    FMG_ANGUS: 'fmgAngus',
    USDA_ANGUS: 'usdaAngus',
    GRAIN_FED: 'grainFed',
    GRASS_FED: 'grassFed',
    SUSTAINABLE: 'sustainable',
    WAGYU: 'wagyu',
  };

  static PRODUCTION_DETAILS = {
    shippedQuantity: null,
    unitOfMeasureId: 3,
    productionDate: null,
  };

  static INCOTERMS = {
    fob: 'FOB',
    fas: 'FAS',
    cif: 'CIF',
    dct: 'DCT',
    cfr: 'CFR',
  };

  static PRODUCT_STATE = [
    { value: true, label: 'Fresh' },
    { value: false, label: 'Frozen' },
  ];

  // This object is used to populated the generated documents section dropdown
  // Please note that invoicing documents should not be included in this object
  // Invoicing documents _can_ be included in the list below this object.
  static GENERATED_DOCUMENTS = {
    confirmationOfPurchase: {
      value: 'confirmation_of_purchase',
      label: 'Confirmation of Purchase',
      docType: 'COP',
      hasNotes: true,
    },
    confirmationOfSale: {
      value: 'confirmation_of_sale',
      label: 'Confirmation of Sale',
      docType: 'COS',
      hasNotes: true,
    },
    // TODO - Uncomment when this is ready.
    certificateOfOrigin: {
      value: 'certificate_of_origin',
      label: 'Certificate of Origin',
      docType: 'COO',
    },
    certificateOfInsurance: {
      value: 'certificate_of_insurance',
      label: 'Certificate of Insurance',
      docType: 'COI',
    },
    forwardingInstructions: {
      value: 'forwarding_instructions',
      label: 'Forwarding Instructions',
      docType: 'FI',
    },
    coldstoreReleasePdf: {
      value: 'coldstore_release_pdf',
      label: 'Coldstore Release PDF',
      docType: 'CRF',
    },
    coldstoreDeliverySchedule: {
      value: 'coldstore_delivery_schedule',
      label: 'Coldstore Delivery Schedule',
      docType: 'Coldstore Delivery Schedule',
    },
    coldstoreDeliveryChange: {
      value: 'coldstore_delivery_change',
      label: 'Coldstore Delivery Change',
      docType: 'Coldstore Delivery Change',
    },
    coldstoreDeliveryCancellation: {
      value: 'coldstore_delivery_cancellation',
      label: 'Coldstore Delivery Cancellation',
      docType: 'Coldstore Delivery Cancellation',
    },
    packingList: {
      value: 'packing_list',
      label: 'Packing List',
      docType: 'PL',
      hasLotNumbers: true,
    },
    multiConfirmationOfPurchase: {
      value: 'multi_confirmation_of_purchase',
      label: 'Multiple Confirmation Of Purchase',
      docType: 'COP',
      hasNotes: true,
    },
    multiConfirmationOfSale: {
      value: 'multi_confirmation_of_sale',
      label: 'Multiple Confirmation Of Sale',
      docType: 'COS',
      hasNotes: true,
    },
  };

  // static SYSTEM_GENERATED_DOCUMENTS = {
  //   prior_grinder_invoice: {
  //     value: 'prior_grinder_invoice',
  //     label: 'Prior Grinder Invoice',
  //     docType: 'prior_grinder_invoice',
  //   },
  //   prior_grinder_invoice: {
  //     // Added for legacy purposes
  //     value: 'prior grinder invoice',
  //     label: 'Prior Grinder Invoice',
  //     docType: 'prior grinder invoice',
  //   },
  //   final_grinder_invoice: {
  //     value: 'final_grinder_invoice',
  //     label: 'Final Grinder Invoice',
  //     docType: 'final_grinder_invoice',
  //   },
  //   regular_grinder_invoice: {
  //     // Added for legacy purposes
  //     value: 'regular grinder invoice',
  //     label: 'Regular Grinder Invoice',
  //     docType: 'regular_grinder_invoice',
  //   },
  // };

  static SYSTEM_GENERATED_DOCUMENTS = {
    prior_grinder_invoice: {
      value: 'prior_grinder_invoice',
      label: 'Prior Grinder Invoice',
      docType: 'prior_grinder_invoice',
    },
    prior_grinder_invoice_legacy: {
      // Added for legacy purposes
      value: 'prior grinder invoice',
      label: 'Prior Grinder Invoice',
      docType: 'prior grinder invoice',
    },
    final_grinder_invoice: {
      value: 'final_grinder_invoice',
      label: 'Final Grinder Invoice',
      docType: 'final_grinder_invoice',
    },
    final_grinder_invoice_legacy: {
      // Added for legacy purposes
      value: 'final grinder invoice',
      label: 'Final Grinder Invoice',
      docType: 'final grinder invoice',
    },
    regular_grinder_invoice: {
      // Added for legacy purposes
      value: 'regular grinder invoice',
      label: 'Regular Grinder Invoice',
      docType: 'regular_grinder_invoice',
    },
    import_bookings: {
      value: 'Import Bookings',
      label: 'Import Bookings',
      docType: 'import_bookings',
    },
    jds_permit: {
      value: 'JDS Permit',
      label: 'JDS Permit',
      docType: 'jds_permit',
    },
    canada_customs_invoice: {
      value: 'Canada Customs Invoice',
      label: 'Canada Customs Invoice',
      docType: 'canada_customs_invoice',
    },
  };

  // It is okay to have invoice doc types in this list.
  static GENERATED_DOCUMENT_TYPES_LIST = [
    ...Object.values(Constants.GENERATED_DOCUMENTS).map(doc => doc.docType),
    ...Object.values(Constants.SYSTEM_GENERATED_DOCUMENTS).map(doc => doc.docType),
  ];

  // Formats available for lot numbers used in Packing List document generation
  static LOT_NUMBER_FORMATS = [
    {
      value: 0,
      label: 'YYYY-MM-DD',
    },
    {
      value: 1,
      label: '01DDMMYY',
    },
    {
      value: 2,
      label: 'DD/MM/YYYY',
    },
    {
      value: 3,
      label: 'YYYYMMDD',
    },
  ];

  static ORDER_SHIPMENT_TYPE = [
    { value: 'DOMESTIC_US_CN', label: 'Domestic USA/Canada' },
    { value: 'DOMESTIC_AU_NZ', label: 'Domestic AU/NZ' },
    { value: 'INTERNATIONAL_US', label: 'International USA' },
    { value: 'INTERNATIONAL_ASIA', label: 'International Asia' },
  ];

  static DESTINATION_PORT_CHARGE_STATUSES = [
    { value: 'collect', label: 'Collect' },
    { value: 'prepaid', label: 'Pre-Paid' },
  ];

  static FINANCE_TABS = {
    results: 'results',
    cart: 'cart',
  };

  static ORDER_MANAGEMENT_PERMISSIONS = {
    single_order: 'chicago_order_form_write',
    create_purchase_order: 'order_form_write',
  };

  static FINANCE_TABS_LIST = ['results', 'cart'];

  static FINANCE_CARTS = {
    invoiceCart: 'invoiceCart',
    priceCart: 'priceCart',
  };

  static BEEF_TYPE_BY_FORECAST_NAME = {
    hedged_lean_beef: 'Lean Beef',
    hedged_fat_beef: 'Fat Beef',
    exposed_lean_beef: 'Lean Beef',
    exposed_fat_beef: 'Fat Beef',
  };

  static ORDER_TYPES = {
    contract: 'Contract',
    spot: 'Spot',
    formula: 'Formula',
    nof: 'NOF',
    frozen_usage: 'Frozen Usage',
  };

  static USER_SETTINGS_UPDATED_MSG = {
    USER_CRED_CHANGED:
      'Your information has been updated. If you reset your password, please check your email for a link to set it again.',
    USER_UI_SWITCH_TO_NEW: 'You have switched to the new design',
    USER_UI_SWITCH_TO_OLD: 'You have switched to the old design',
  };

  static PRODUCT_TYPES = [
    { value: 'BEEF', label: 'Beef' },
    { value: 'PORK', label: 'Pork' },
  ];

  static FRESH_OR_FROZEN = [
    { value: 'true', label: 'FRESH' },
    { value: 'false', label: 'FROZEN' },
  ];

  static PRODUCT_TYPE_LIST = {
    BEEF: 'BEEF',
    PORK: 'PORK',
  };

  static DROP_TRAILER_OPTIONS = [
    { value: '', label: 'None' },
    { value: true, label: 'Yes' },
    { value: false, label: 'No' },
  ];

  static ORDER_MISSING_DOC_TYPE_OPTIONS = [
    { value: 'Grinder Copy Documents', label: 'Grinder Copy Documents' },
    { value: 'Forwarding Instructions', label: 'Forwarding Instructions' },
  ];

  static TRUE_FALSE_OPTIONS = [
    { value: 'true', label: 'Yes' },
    { value: 'false', label: 'No' },
  ];

  static IN_SPEC_STATUS = { NO_DATA: 'no_data', IN_SPEC: 'in_spec', NOT_IN_SPEC: 'not_in_spec' };

  static BUSINESS_OFFICES = {
    SYDNEY: { value: 'Sydney', label: 'Sydney' },
    CHICAGO: { value: 'Chicago', label: 'Chicago' },
  };

  static DEFAULT_PACKER_PLANT_DATA = {
    byCategory: [],
    byMarket: [],
    claimDollars: 0,
    incidentRate: 0,
    incidentsCount: 0,
    percentOfMarket: 0,
    percentOfTotalVolume: 0,
    receivedWeight: 0,
    totalVolume: 0,
    weight: 0,
  };

  static DEFAULT_CATEGORY_DATA = {
    incidentsCount: 0,
    incidentRate: 0,
    totalVolume: 0,
    percentOfTotalVolume: 0,
    percentOfMarket: 0,
    weight: 0,
    claimDollars: 0,
    receivedWeight: 0,
  };

  static CATEGORY_COLORS = [
    '#1CA6B2',
    '#F01D82',
    '#805CFF',
    '#F2C94C',
    '#00B5F2',
    '#FC5D36',
    '#006df2',
    '#FF9A3D',
    '#545B72',
    '#AB2424',
    '#029916',
  ];

  static FIELD_TYPES = {
    string: 'string',
    number: 'number',
    reference: 'reference',
    date: 'date',
    money: 'money',
  };

  static UNLEASH_FLAG = {
    INVOICING: 'invoicing',
    COLD_STORE: 'cold_store',
    ARTICLES: 'articles',
    DAILY_TASKS: 'daily_task',
    DRAWDOWN_REPORT: 'drawdown_report',
    SELF_SERVICE_REPORT: 'self_service_report',
    BUSINESS_PERFORMANCE: 'business_performance',
    BUY_ACTIVITY: 'buy_activity',
    CREATE_ORDER: 'create_order',
    BULK_UPDATER: 'bulk_updater',
    ORDER_MANAGEMENT: 'order_management',
    // Children Routes
    SYDNEY_ORDER: 'sydney_order',
    CHICAGO_ORDER: 'chicargo_order',
    TREASURY_DASHBOARD: 'treasury_dashboard',
    QUALITY_DASHBOARD: 'quality_dashboard',
    KPI_INSIGHTS: 'kpi_insight',
    MARKET_DASHBOARD: 'market_dashboard',
    // Market Dashboard Components
    MARKET_DASHBOARD_COST_PERFORMANCE: 'market_dashboard_cost_performance',
    MARKET_DASHBOARD_MC_MENU: 'market_dashboard_mc_menu',
    MARKET_DASHBOARD_SUPPLY_CHAIN: 'market_dashboard_supply_chain',
    MARKET_DASHBOARD_SCALE_FOR_GOOD: 'market_dashboard_scale_for_good',
    MARKET_DASHBOARD_SCALE_QUALITY: 'market_dashboard_quality',
  };

  static VIEW_COLS = [
    { key: 'load_port_id', name: 'Port Of Loading' },
    { key: 'discharge_port_id', name: 'Port Of Discharge' },
    { key: 'packer_ingredient_description', name: 'Product Description' },
    { key: 'sell_quantity', name: 'Sell Quantity' },
  ];

  static ACTION_TYPES = [
    { label: 'coldstore_scheduled', value: 'coldstore_scheduled' },
    { label: 'coldstore_released', value: 'coldstore_released' },
    { label: 'confirmation_of_sale', value: 'confirmation_of_sale' },
    { label: 'confirmation_of_purchase', value: 'confirmation_of_purchase' },
    { label: 'invoice', value: 'invoice' },
    { label: 'invoice_prior', value: 'invoice_prior' },
    { label: 'invoice_final', value: 'invoice_final' },
    { label: 'forwarding_instruction', value: 'forwarding_instruction' },
    { label: 'new_ncr_created', value: 'new_ncr_created' },
    { label: 'new_ncr_communication_channel', value: 'new_ncr_communication_channel' },
    { label: 'ncr_overdue_action_required', value: 'ncr_overdue_action_required' },
    { label: 'ncr_removal_with_reason_provided', value: 'ncr_removal_with_reason_provided' },
    { label: 'ncr_approved_and_closed', value: 'ncr_approved_and_closed' },
    { label: 'ncr_packer_added_initial_investigation', value: 'ncr_packer_added_initial_investigation' },
    { label: 'ncr_packer_added_final_investigation', value: 'ncr_packer_added_final_investigation' },
    { label: 'ncr_packer_accepted_claim_value', value: 'ncr_packer_accepted_claim_value' },
    { label: 'ncr_packer_rejected_claim_value', value: 'ncr_packer_rejected_claim_value' },
    { label: 'ncr_packer_updated_initial_investigation', value: 'ncr_packer_updated_initial_investigation' },
    { label: 'ncr_packer_updated_final_investigation', value: 'ncr_packer_updated_final_investigation' },
    { label: 'ncr_investigation_details_not_added', value: 'ncr_investigation_details_not_added' },
    { label: 'ncr_initial_investigation_details_not_added', value: 'ncr_initial_investigation_details_not_added' },
    { label: 'ncr_final_investigation_details_not_added', value: 'ncr_final_investigation_details_not_added' },
    { label: 'ncr_claim_value_not_accepted', value: 'ncr_claim_value_not_accepted' },
    { label: 'PartnerPortal_Received_Weights_CL_Temperature', value: 'PartnerPortal_Received_Weights_CL_Temperature' },
  ];

  static DOC_ACTION_TYPES = {
    cos: ['confirmation_of_sale', 'internal_users'],
    cop: ['confirmation_of_purchase', 'internal_users'],
    fi: ['forwarding_instruction', 'internal_users'],
  };

  static BULK__PAGE_LIMIT = [
    { label: '50', value: 50 },
    { label: '100', value: 100 },
    { label: '200', value: 200 },
  ];

  static INITIAL_SURCHARGES = {
    quantity: '',
    uomId: '',
    value: '',
    name: '',
  };

  static mapTenantIDToAppName = {
    tarot: 'boab',
    fmg: 'boab',
    cfc: 'fuze',
  };

  static VOYAGE_DATE_TYPES = ['eta', 'etd'];

  static INVOICE_GRID_DATE_TYPES = ['invoice_payment_due_date', 'packer_paid_date'];

  static TWO_FACTOR_AUTH_METHOD = [
    { label: 'Email', value: 'email' },
    { label: 'Authentication App', value: 'authentication_app' },
  ];

  static LOAD_NOTES_CATEGORIES = [
    {
      label: 'Trucking',
      value: 'trucking',
    },
    {
      label: 'Paperwork',
      value: 'paperwork',
    },
    {
      label: 'Grinder',
      value: 'grinder',
    },
    {
      label: 'Product',
      value: 'product',
    },
  ];

  static LOAD_NOTES_REASONS = [
    {
      label: 'Weather - same day',
      value: 'weather_same_day',
      categories: ['trucking'],
    },
    {
      label: 'Weather - next day',
      value: 'weather_next_day',
      categories: ['trucking'],
    },
    {
      label: 'Carrier Failure - same day',
      value: 'carrier_failure_same_day',
      categories: ['trucking'],
    },
    {
      label: 'Carrier Failure - next day',
      value: 'carrier_failure_next_day',
      categories: ['trucking'],
    },
    {
      label: 'Packer could not fill load resulting in late truck - same day',
      value: 'packer_could_not_fill_load_resulting_in_late_truck_same_day',
      categories: ['trucking'],
    },
    {
      label: 'Packer could not fill load resulting in late truck - next day',
      value: 'packer_could_not_fill_load_resulting_in_late_truck_next_day',
      categories: ['trucking'],
    },
    {
      label: 'Damage to load but received by grinder',
      value: 'damage_to_load_but_received_by_grinder',
      categories: ['trucking'],
    },
    {
      label: 'COA - late COA',
      value: 'coa_late_coa',
      categories: ['paperwork'],
    },
    {
      label: 'COA - wrong PO',
      value: 'coa_wrong_po',
      categories: ['paperwork'],
    },
    {
      label: 'COA - other',
      value: 'coa_other',
      categories: ['paperwork'],
    },
    {
      label: 'BOL - seal does not match',
      value: 'bol_seal_does_not_match',
      categories: ['paperwork'],
    },
    {
      label: 'BOL - wrong PO',
      value: 'bol_wrong_po',
      categories: ['paperwork'],
    },
    {
      label: 'BOL - no seal but accepted by grinder',
      value: 'bol_no_seal_but_accepted_by_grinder',
      categories: ['paperwork'],
    },
    {
      label: 'BOL - other',
      value: 'bol_other',
      categories: ['paperwork'],
    },
    {
      label: 'Not received - poor production/cooler capacity',
      value: 'not_received_poor_production/cooler_capacity',
      categories: ['grinder'],
    },
    {
      label: 'Not received - labor',
      value: 'not_received_labor',
      categories: ['grinder'],
    },
    {
      label: 'Not received - other',
      value: 'not_received_other',
      categories: ['grinder'],
    },
    {
      label: 'Sampled at Border',
      value: 'sampled_at_border',
      categories: ['product'],
    },
  ];

  static ARTICLE_HOOK_MAX_LEN = 104;

  static CLAIM_ENTITY_TYPES = [
    {
      value: 'quantity',
      label: 'Quantity',
    },
    {
      value: 'time',
      label: 'Time',
    },
    {
      value: 'other',
      label: 'Other',
    },
  ];

  static NCR_ADMIN_GRINDER_CLOSURE_OPTIONS = [
    {
      label: 'Accepted',
      value: 'accepted',
    },
  ];

  static NCR_ADMIN_REVIEW_OPTIONS = [
    {
      label: 'Reviewed',
      value: 'reviewed',
    },
  ];

  static NCR_ADMIN_ACCEPTANCE_OPTIONS = [
    {
      label: 'Accepted',
      value: 'accepted',
    },
  ];

  static NCR_PACKER_ACCEPTANCE_OPTIONS = [
    {
      label: 'Accepted',
      value: 'accepted',
    },
    {
      label: 'Rejected',
      value: 'rejected',
    },
    {
      label: 'Under Review',
      value: 'under_review',
    },
  ];

  static CLAIM_STATUSES = {
    MINOR: 'minor',
    MAJOR: 'major',
    SERIOUS: 'serious',
  };

  static NCR_STATUES = {
    INPROGRESS: 'in_progress',
    OPEN: 'open',
    CLOSED: 'closed',
    UNDER_REVIEW: 'under_review',
    REJECTED: 'rejected',
    RAISED: 'raised',
  };

  static NCR_TYPES = {
    NCR: 'ncr',
    INCIDENT: 'incident',
    ENTRAPMENT: 'entrapment',
  };

  static BRANDS = {
    INSPIRE_BRANDS: 'inspire_brands',
  };

  static RESOURCE_DOCUMENT_TYPES = {
    btt: 'btt',
    beef_bundle: 'beef_bundle',
    annual_audit_report: 'annual_audit_report',
    audit_certificate: 'audit_certificate',
    haccp: 'haccp',
    spec: 'spec',
    letter_of_guarantee: 'letter_of_guarantee',
    allergen_statements: 'allergen_statements',
    animal_welfare_audit_report: 'animal_welfare_audit_report',
    coa_example: 'coa_example',
    other: 'other',
  };

  static boningProcesses = [
    { label: 'Hot', value: 'Hot' },
    { label: 'Cold', value: 'Cold' },
  ];

  static days = [
    {
      label: 'Monday',
      value: 'Monday',
    },
    {
      label: 'Tuesday',
      value: 'Tuesday',
    },
    {
      label: 'Wednesday',
      value: 'Wednesday',
    },
    {
      label: 'Thursday',
      value: 'Thursday',
    },
    {
      label: 'Friday',
      value: 'Friday',
    },
    {
      label: 'Saturday',
      value: 'Saturday',
    },
    {
      label: 'Sunday',
      value: 'Sunday',
    },
  ];

  static shifts = [
    { label: 'Morning', value: 'Morning' },
    { label: 'Afternoon', value: 'Afternoon' },
    { label: 'Evening', value: 'Evening' },
    { label: '1 Shift', value: '1 Shift' },
    { label: '2 Shifts', value: '2 Shifts' },
  ];

  static rawMaterials = [
    { label: 'Frozen Cartons', value: 'Frozen Cartons' },
    { label: 'Fresh Cartons', value: 'Fresh Cartons' },
  ];

  static category = [
    { label: 'Beef', value: 'Beef' },
    { label: 'Pork', value: 'Pork' },
    { label: 'Poultry', value: 'Poultry' },
  ]
}

setRequestContentType(Constants.URL);
